import React, { useState, useEffect } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
  FormHelperText
} from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { disponibiliteOptions as defaultOptions } from './constants/options';

const DisponibilitePicker = ({
  label = 'Disponibilité',
  value,
  onChange,
  error,
  helperText,
  required = false,
  options = defaultOptions
}) => {
  const [selectedOption, setSelectedOption] = useState('');

  useEffect(() => {
    if (value instanceof Date) {
      const now = new Date();
      const inOneMonth = new Date();
      const inThreeMonths = new Date();
      inOneMonth.setMonth(inOneMonth.getMonth() + 1);
      inThreeMonths.setMonth(inThreeMonths.getMonth() + 3);

      if (Math.abs(value - now) < 86400000) {
        setSelectedOption('immédiat');
      } else if (
        Math.abs(value - inOneMonth) < 86400000 * 3 
      ) {
        setSelectedOption('1 mois');
      } else if (
        Math.abs(value - inThreeMonths) < 86400000 * 3
      ) {
        setSelectedOption('3 mois');
      } else {
        setSelectedOption('autre');
      }
    } else {
      setSelectedOption('');
    }
  }, [value]);

  const handleSelectChange = (val) => {
    setSelectedOption(val);

    if (val === 'immédiat') {
      onChange(new Date());
    } else if (val === '1 mois') {
      const date = new Date();
      date.setMonth(date.getMonth() + 1);
      onChange(date);
    } else if (val === '3 mois') {
      const date = new Date();
      date.setMonth(date.getMonth() + 3);
      onChange(date);
    } else {
      onChange(null);
    }
  };

  return (
    <>
      <FormControl fullWidth error={!!error} required={required}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={selectedOption}
          onChange={(e) => handleSelectChange(e.target.value)}
          label={label}
        >
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </Select>
        {helperText && <FormHelperText>{helperText}</FormHelperText>}
      </FormControl>

      {selectedOption === 'autre' && (
        <DatePicker
          label="Sélectionner une date"
          value={value instanceof Date ? value : null}
          onChange={onChange}
          disablePast
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              error={!!error}
              helperText={helperText}
              required={required}
            />
          )}
        />
      )}
    </>
  );
};

export default DisponibilitePicker;
